import { Badge } from '@chakra-ui/react';
import { ChurnTier } from '../../../models/churn-prediction/dto/churn-prediction.dto';
import { translate, TranslationKeys } from '../../../i18n';
import { TIER_COLORS, TIER_LABEL_KEYS } from '../utils/churn.utils';

export default function ChurnTierBadge({ tier }: { tier: ChurnTier }) {
  return (
    <Badge colorScheme={TIER_COLORS[tier]} fontSize="sm">
      {translate(TIER_LABEL_KEYS[tier] as TranslationKeys)}
    </Badge>
  );
}
